var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photoBox"},_vm._l((_vm.photoUrls),function(item,index){return _c('img',{key:index,class:[_vm.photoselect === index ? 'active' : 'photoImg'],attrs:{"src":item},on:{"click":function($event){return _vm.imgphoto(index)}}})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64fa8c0e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/leftAside/digital_industry/companyInformation/menu2.vue
// module id = null
// module chunks = 